import { Typography } from '@breetometer/components';
import { capitalizeFirstLetter } from 'BreetHelpers';
import type { RefObject } from 'react';

import type { ICurrencyDropDown } from '../../Dropdown.helpers';
import { CurrencyDropDownControl } from '../controls/Currency';
import { CurrencyDropdownItems } from '../items/Currency';
import { DropdownWrapper } from '../Wrapper';

const CurrencyDropDown = ({
	handleItemSelect,
	selectedItem,
	items,
	placeholder,
	children,
	errorMessage,
	hideSearch,
	CustomItemOption,
}: ICurrencyDropDown) => (
	<div
		className='dropdown'
		data-testid='dropdown'
	>
		<DropdownWrapper>
			{(dropDownArgs) => {
				const { buttonRef, handleVisibility, visible, dropdownRef, controlRef, dropdownStyles } = dropDownArgs;

				return (
					<div className='dropdowninput bg-primary-500 border-dark-navy'>
						<div
							className='dropdown_content'
							ref={controlRef as RefObject<HTMLDivElement>}
						>
							<CurrencyDropDownControl
								selectedItem={selectedItem}
								buttonRef={buttonRef}
								handleVisibility={handleVisibility}
								visible={visible}
							/>

							{children}

							{visible && (
								<CurrencyDropdownItems
									handleItemSelect={handleItemSelect}
									dropDownRef={dropdownRef}
									hideSearch={hideSearch}
									selectedItem={selectedItem}
									items={items}
									placeholder={placeholder}
									dropdownStyles={dropdownStyles}
									handleVisibility={handleVisibility}
									CustomItemOption={CustomItemOption}
								/>
							)}
						</div>
					</div>
				);
			}}
		</DropdownWrapper>
		{!!errorMessage && (
			<Typography
				as='p'
				className='dropdown_errormessage'
			>
				{capitalizeFirstLetter(errorMessage)}
			</Typography>
		)}
	</div>
);

export default CurrencyDropDown;
